import React from 'react'
import {Helmet} from 'react-helmet'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import PropTypes from 'prop-types'

const BootstrapProvider = ({children}) => {
    return (
        <>
            <Helmet>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href={getAssetUrl('static/bootstrap.min.css')}
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css"
                />
            </Helmet>
            {children}
        </>
    )
}

BootstrapProvider.propTypes = {
    children: PropTypes.node.isRequired
}
export default BootstrapProvider
